import { graphql } from 'react-relay';

export const tagConnectionFragment = graphql`
    fragment tagConnectionFragment on TagConnection {
        edges {
            cursor
            node {
                ...tagFragment
            }
        }
        pageInfo {
            ...pageInfoFragment
        }
    }
`;
